import head from "lodash/head"
import commonApiAuthRequest from "../apiAuthRequest"
import { MAPISSUES_CORE_URL } from "./constants"

/*
  Спека
  https://next.stoplight.io/infotech-group/4sides/version%2F1.0/mi-core.oas2.yml?view=%2Fissues%2Fget-issues
*/

const issueFetch = eventId =>
  commonApiAuthRequest({
    url: `${MAPISSUES_CORE_URL}/issues`,
    params: { query: `externalId==${eventId}` },
  })

/**
 * makes request to get issue by eventId
 *
 * @param {number} eventId
 * @return {Array.<Object>} response - issue
 */
export const getIssueByEvent = async eventId => {
  if (!eventId) {
    return undefined
  }

  const { data: issueList } = await issueFetch(eventId)

  return head(issueList)
}

const issueStatusFetch = statusId =>
  commonApiAuthRequest({
    url: `${MAPISSUES_CORE_URL}/issues/statuses/${statusId}`,
    params: {},
  })

/**
 * makes request to get issue status by statusId
 *
 * @param {number} statusId
 * @return {Array.<Object>} response - issue status
 */
export const getStatusById = async statusId => {
  if (!statusId) {
    return undefined
  }

  const { data: status } = await issueStatusFetch(statusId)

  return status
}

export const ISSUE_TYPE_CODES = {
  repair: `toir_repair`, // Заявка на ремонт
  techReview: `tech_review`, // Технический осмотр
  vehicleRequest: `vehicle_request_issue`, // Заявка на выделение ТС
  tmc: `tmc_issues_oek`, // Заявка на ТМЦ
  measurement: `toir_measurement`, // Измерения, испытания, замеры
  techService: `tech_service`, // Тех обслуживание
}
